<template>
  <div class="wlx-site-manager-wrapper">
    <header class="site-manager-head-con">
      <el-form :inline="true" size="small">
        <el-select v-model="SiteType" placeholder="申请状态"  @change="getSitesList()" clearable>
          <el-option v-for="item in options"
                    :key="item.value"
                    :label="item.value"
                    :value="item.id">
          </el-option>
        </el-select >
        <el-form-item>
          <el-input v-model="DisplayName" placeholder="站点名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getSitesList()">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-check" @click="AuditingSites()">批量审核通过</el-button>
        </el-form-item>
      </el-form>
    </header>

    <el-table
      :data="siteList"
      @selection-change="handleSelectionChange"
      :row-key="getRowKeys"
      style="width: 100%"
      v-if="tableShow"
    >
      <el-table-column prop="Id" type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="SiteTitle" label="站点名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="DateCreated" label="申请时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="Province" label="城市" show-overflow-tooltip></el-table-column>
      <el-table-column label="申请为培训站点" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.IsTrain == 1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="申请为考试站点" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.IsExam == 1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column label="申请状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <span style="color:#05C94F" v-if="scope.row.IsAuthentication==0">待审核</span>
          <span style="color:#2D82FF" v-if="scope.row.IsAuthentication==1">审核通过</span>
          <span style="color:#E53939" v-if="scope.row.IsAuthentication==2">审核未通过</span>          
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button  size="mini" class="el-icon-edit"  @click="edit(scope.row)" type="primary" title="审核"></el-button>
          <!-- <el-button type="success" size="mini" @click="AudingSites(scope.row.Id,1)">通过</el-button>
          <el-button type="danger" size="mini" @click="AudingSites(scope.row.Id,2)">不通过</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        v-show="totalCount>0"
        style="text-align: center;"
      ></el-pagination>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="50%"
      :append-to-body="true"
      :close-on-click-modal="false">
      <!-- <span>这是一段信息</span>
      <UploadFile></UploadFile> -->
      <el-form  ref="ruleForm2" label-width="100px">
        <el-form-item label="站点名：" prop="pass">
          <span>{{siteTiele}}</span>
        </el-form-item>
        <el-form-item label="申请材料：" prop="checkPass">
          <applyFileUpload :url="urlAliyunOSS" :files="files" :IsUpload="false"></applyFileUpload>
        </el-form-item>
        <el-form-item label="审核：">
          <el-radio-group v-model="IsAuthentication">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="AudingSites()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { debuggerStatement } from "babel-types";
import applyFileUpload from "components/UploadFile.vue";
export default {
  data() {
    return {
      DisplayName: "",
      siteList: [],
      pageSize: 10,
      page: 1,
      totalCount: 0,
      ids: [],
      tableShow: true,
      getRowKeys(row) {
        return row.Id;
      },
      dialogVisible:false,
      siteId:"",
      siteTiele:"",
      urlAliyunOSS:'/api/design/osssign/getsign',
      files:[],
      options:[{id:0, value:"待审核"},{id:1, value:"审核通过"},{id:2, value:"审核未通过"}],
      SiteType: "",
      IsAuthentication: 1,
      
    };
  },
  components: {
    applyFileUpload
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  created() {
    this.getSitesList();
  },
  methods: {
    getSitesList() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/getAudingSites", {
          title: this.DisplayName,
          siteType:  this.SiteType.toString()==""?-1:this.SiteType,
          pageSize: this.pageSize,
          page: this.page
        })
        .then(function(rst) {
          that.siteList = rst.list;
          that.pageSize = rst.pagination.pageSize;
          that.totalCount = rst.pagination.totalCount;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getSitesList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getSitesList();
    },
    AuditingSites() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/AuditingSites", {
          ids: this.ids,
          state: 1
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.tableShow = false;
            that.$message.success(rst.msg);
            that.getSitesList();
            that.$nextTick(() => {
              that.tableShow = true;
            });
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    handleSelectionChange(val) {
      var that = this;
      this.ids = [];
      val.forEach(el => {
        that.ids.push(el.Id);
      });
    },
    AudingSites() {
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/AuditingSites", {
          ids: that.siteId,
          state: that.IsAuthentication
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.getSitesList();
            that.dialogVisible = false;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    edit(row){
      var that = this;
      this.$http
        .post("/api/XOrg/AssociationSites/getSitesFiles", {
          siteId: row.Id
        })
        .then(function(rst) {
          if(rst.code > 0){
            that.files = rst.files;
            that.siteTiele = row.SiteTitle;
            that.siteId = row.Id;
            that.dialogVisible = true;
          }else{
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper{
  .el-input--suffix .el-input__inner{
    padding-right: 30px;
    height: 34px;
  }
}

</style>
